import React from 'react'
import { getTranslation } from '../translations'

export default function Disclaimer({ language = 'english', partnerName = null, customText = null }) {
  const t = getTranslation(language)
  if (customText) {
    return (
      <div className="mt-8">
        <h2 className="text-xl font-extrabold text-[#134225] text-center">{t.disclaimer}</h2>
        <div className="max-w-5xl mx-auto mt-8 text-gray-700 leading-7 text-sm">
          <p className="text-justify" style={{ whiteSpace: 'pre-wrap' }}>
            {customText}
          </p>
        </div>
      </div>
    )
  }
  
  const hasPartner = partnerName && partnerName !== 'Ekosight Technologies Private Limited'
  const disclaimerText = hasPartner ? t.disclaimerWithPartner : t.disclaimerWithoutPartner
  
  const finalDisclaimerText = hasPartner 
    ? disclaimerText.replace(/\[Partner Name\]/g, partnerName)
    : disclaimerText
  
  return (
    <div className="mt-8">
      <h2 className="text-xl font-extrabold text-[#134225] text-center">{t.disclaimer}</h2>
      <div className="max-w-5xl mx-auto mt-8 text-gray-700 leading-7 text-sm">
        <p className="text-justify">
          {finalDisclaimerText}
        </p>
      </div>
    </div>
  )
}
